module.exports = "/_next/static/images/contactUs-e25f8412c8401e795f366f7dd9134c18.png";